export const isJsonValidate = (str) => {
  try {
    if (str?.length >= 2) {
      JSON.parse(str)
    }
  } catch (e) {
    return 'ra.field.invalid_json'
  }
  return undefined
}
